import { useIsHomepage } from '#pplx/frontend/apps/ask/hooks/homepage-hooks/useIsHomepage.js';
import { isCometLandingPage } from '#pplx/frontend/apps/ask/routing/routes.js';
import { resolveSuggestionsDisabled } from '#pplx/frontend/apps/ask/suggest-dropdown/hooks/resolveSuggestionsDisabled.js';
import { useLocalUserSettings } from '#pplx/frontend/apps/ask/user-settings/getLocalUserSettings.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { useMemo } from 'react';
/** Resolves the input's suggestion gates with the current route and user preference. */
export function useAskInputSuggestionPolicy(options) {
    return useAskInputSuggestionPolicySnapshot(options).suggestionsDisabled;
}
/** Captures policy inputs so a provider can recheck an editor edit before the next render. */
export function useAskInputSuggestionPolicySnapshot({ autosuggestionsEnabled, hasThreadContent, inputQuery, querySource, suggestions, }) {
    const pathname = usePathname();
    const [isSuggestionsDisabled] = useLocalUserSettings('isSuggestionsDisabled', false);
    const isHomepage = useIsHomepage();
    const isCometHomepage = isCometLandingPage(pathname);
    return useMemo(() => {
        const policy = {
            autosuggestionsEnabled,
            hasThreadContent,
            inputQuery,
            isCometHomepage: !!isCometHomepage,
            isHomepage,
            isSuggestionsDisabled,
            querySource,
            suggestions,
        };
        return { policy, suggestionsDisabled: resolveSuggestionsDisabled(policy) };
    }, [
        isSuggestionsDisabled,
        autosuggestionsEnabled,
        isHomepage,
        isCometHomepage,
        querySource,
        inputQuery,
        hasThreadContent,
        suggestions,
    ]);
}
//# sourceMappingURL=useAskInputSuggestionPolicy.js.map